import { useNavigate } from 'react-router-dom'
import { type ScannedContainer } from '../../../client/scanner/scanner.types'

export const useGoToMoveOptionsNavigator = () => {
  const navigate = useNavigate()

  return {
    go: (origin: ScannedContainer) => {
      navigate(STORAGE_MOVE_OPTIONS_URL.replace(':origin', origin.container.name))
    }
  }
}

export const STORAGE_MOVE_OPTIONS_URL = '/to-storage/:origin/choose'
